// @ts-nocheck
import moment from 'moment-timezone';
import React from 'react';
import { useIntl } from 'react-intl';
import { AssistantChat } from 'sonata-platform-components';

import { ReportingAssistantChatStyled } from './ReportingAssistantChat.styled';

import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

type Props = {
  campaigns: Record<string, any>[];
  currency: string;
  user?: UserInterface;
  userRoles: UserRoleInterface[];
};

const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';

export function ReportingAssistantChat({ campaigns, currency, user, userRoles }: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const campaignIds = campaigns.map(campaign => campaign.id);
  const { timezone } = campaigns[0];
  const { endDate, startDate } = campaigns.reduce(
    (acc, campaign) => {
      if (campaign.beginDate < acc.startDate) {
        acc.startDate = campaign.beginDate;
      }
      if (campaign.endDate > acc.endDate) {
        acc.endDate = campaign.endDate;
      }
      return acc;
    },
    {
      endDate: campaigns[0].endDate,
      startDate: campaigns[0].beginDate
    }
  );

  const agentContextParams = {
    campaignIds,
    campaignType: campaigns[0].type,
    currency,
    endDate: moment.tz(endDate, timezone).endOf('day').format(DATE_FORMAT),
    startDate: moment.tz(startDate, timezone).startOf('day').format(DATE_FORMAT),
    timezone,
    userCountry: user?.country,
    userId: user?.id
  };

  return (
    <ReportingAssistantChatStyled>
      <AssistantChat
        buttonText={formatMessage({
          defaultMessage: 'Smart Report',
          id: 'reporting.aiChat.buttonText'
        })}
        defaultAgentId="reporting_assistant_v4"
        id="reportingAssistantChat"
        metadata={{
          agentContext: `
            I have some contextual information that might help answer the user's question:
            ${Object.entries(agentContextParams || {})
              .map(([key, value]) => `[${key.toUpperCase()}]: ${value}`)
              .join('\n')}
            
            If this context is not sufficient, you have access to various tools that you can use to gather more information.
            Always prioritize giving accurate and complete answers.
            If you need real-time or additional data, please use the available tools.
          `,
          mcpContext: agentContextParams
        }}
        startUpMessageText={formatMessage({
          defaultMessage: 'Can I help you understand your report better?',
          id: 'assistantChat.messages.reporting'
        })}
        user={user}
        userRoles={userRoles}
      />
    </ReportingAssistantChatStyled>
  );
}
